import { bigQuery } from '@fiverr-private/obs';
import { DOMAIN, SUB_DOMAIN, BI_EVENT_GROUPS, BI_ACTION_TYPES } from './constants';

export const biPageView = (eventData) => bqEvent({ group: BI_EVENT_GROUPS.PAGE_VIEW, ...eventData });
export const biImpression = (eventData) => bqEvent({ group: BI_EVENT_GROUPS.USER_IMPRESSION, ...eventData });
export const biUserAction = (eventData) => bqEvent({ group: BI_EVENT_GROUPS.USER_ACTION, actionType: BI_ACTION_TYPES.CLICK, ...eventData });
export const bqEnrichment = ({ type, group, actionType, pageCtxId, page, gig, source, payload = {} }) => ({
    type,
    group,
    event_source: source,
    action: {
        type: actionType
    },
    domain: {
        name: DOMAIN
    },
    publisher: {
        domain: DOMAIN,
        sub_domain: SUB_DOMAIN
    },
    page: {
        ctx_id: pageCtxId,
        ...(page && page)
    },
    ...gig && { gig },
    ...payload
});

export const bqEvent = ({ type, group, actionType, pageCtxId, page, gig, source, payload = {} }) => {
    const enrichment = bqEnrichment({ type, group, actionType, pageCtxId, page, gig, source, payload });

    bigQuery.send(enrichment);
};
